<template>
    <div>
        <!-- TrustBox widget - Micro Star -->
        <div class="trustpilot-widget-testimonials tw-mt-4" data-locale="de-DE" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="6249a28d40123731d8da3c4e" data-style-height="24px" data-style-width="100%" data-token="d57c8ec4-ae00-4668-91c0-a7e464cd3145">
            <a href="https://de.trustpilot.com/review/wedesigntrips.com " target="_blank" rel="noopener">Trustpilot</a>
        </div>
        <!-- End TrustBox widget -->
        <div
            class="tw-my-8 tw-pt-8 tw-border-t-2 tw-border-red-500"
        >
            <div
                class="tw-text-center tw-mb-4"
            >
                Unsere lokalen Experten werden empfohlen von
            </div>
            <div
                class="tw-space-y-4 tw-justify-center tw-items-center"
            >
                <logo-die-welt/>
                <logo-national-geographic/>
                <LogoLonelyPlanet class="tw-mx-auto"/>
            </div>
        </div>
    </div>
</template>

<script>
import LogoDieWelt from "../icons/LogoDieWelt.vue";
import LogoNationalGeographic from "../icons/LogoNationalGeographic.vue";
import LogoLonelyPlanet from "../icons/LogoLonelyPlanet.vue";

    export default {
        name: "Testimonials",
        components: {
            LogoLonelyPlanet,
            LogoNationalGeographic,
            LogoDieWelt,
        },
        props: {
            icon: {
                type: String,
            },
            coloredIcon: Boolean,
        },
        data() {
            return {
                widgetLoaded: false
            }
        },
        mounted() {
            this.tryInitTrustpilot();
        },
        methods: {
            tryInitTrustpilot(retries = 20, interval = 250) {
                const widget = document.querySelector('.trustpilot-widget-testimonials');
                if (!widget) return;

                const tryLoad = () => {
                    if (window.Trustpilot) {
                        window.Trustpilot.loadFromElement(widget);
                    } else if (retries > 0) {
                        setTimeout(() => {
                            this.tryInitTrustpilot(retries - 1);
                        }, interval);
                    } else {
                        console.log('Trustpilot widget failed to load after waiting.');
                    }
                };
                tryLoad();
            }
        }
    }
</script>

<style scoped>
</style>